import React from 'react';
import AsyncMenu from './uiconfiguration/menu';
import AsyncGetSkinResult from './uiconfiguration/getskinresult';
import AsyncLandingPage from './uiconfiguration/landingpage';
import AsyncLandingPageV2 from './uiconfiguration/landingpagev2';
import AsyncCommonPage from './uiconfiguration/commonsettings';
import AsyncUserConsent from './uiconfiguration/userconsent';
import AsyncSurveyFormConfig from './uiconfiguration/surveyform';
import AsyncSkincareDetection from './uiconfiguration/skincaredetection';
import AsyncSkinResultPage from './uiconfiguration/skinresultpage';
import AsyncSkinResultPageV2 from './uiconfiguration/skinresultpagev2';
import AsyncSharedSkinResultPage from './uiconfiguration/sharedskinresultpage';
import AsyncSimulationPage from './uiconfiguration/simulationpage';
import AsyncSimulationReport from './uiconfiguration/simulationreport';
import AsyncSharedSimulationReportPage from './uiconfiguration/sharedsimulationreportpage';
import AsyncFaceAssessment from './uiconfiguration/faceassessment';
import AsyncSkincareProduct from './addskincare/skincareproduct/listskincareproduct';
import AsyncSkincareRoutine from './addskincare/skincareroutine/listskincareroutine';
import AsyncSkincareTreatment from './addskincare/skincaretreatment/listskincaretreatment';
import AsyncAddOrEditSkincareRoutine from './addskincare/skincareroutine/addoreditskincareroutine';
import AsyncAddOrEditSkincareProduct from './addskincare/skincareproduct/addoreditskincareproduct';
import AsyncAddOrEditSkincareTreatment from './addskincare/skincaretreatment/addoreditskincaretreatment';
import AsyncCategoryManagement from './addskincare/categorymanagement/listcategorymanagement';
import AsyncRuleBasedRecommendation from './recommendationrule/rulebasedrecommendation/async';
import AsyncCustomizedRecommendation from './recommendationrule/customizedrecommendation/async';
import AsyncRecommendationList from './recommendationrule/listrules/async';
import AsyncAiRecommendation from './recommendationrule/airecommendation/async';
import AsyncEmailCustomization from './emailcustomization/async';
import AsyncSurveyForm from './surveyform/listsurveyform/async';
import AddOrEditOrViewSurveyForm from './surveyform/addoreditorviewsurveyform/async';
import EditTranslateSurveyForm from './surveyform/editTranslateSurveyForm/async';
import AsyncAppSettings from './uiconfiguration/appsettings/async';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';
import UiConfiguarationLayout from '../../components/layout/UiConfiguarationLayout';

const parent1 = {
  title: <Trans i18nKey="p.s.uiconfiguration.title">UI Configuration</Trans>,
  path: '/skincare-pro/ui-configuration',
};

const parent2 = {
  title: <Trans i18nKey="p.s.addskincare.title">Product Management</Trans>,
  path: '/skincare-pro/add-skincare',
};

const parent3 = {
  title: (
    <Trans i18nKey="c.l.sidebar.1100.skincarepro.title">Skincare Pro</Trans>
  ),
  path: '/skincare-pro/recommendation-rule',
};

const parent4 = {
  title: (
    <Trans i18nKey="c.l.sidebar.1100.skincarepro.title">Skincare Pro</Trans>
  ),
  path: '/skincare-pro',
};

const parent5 = {
  title: (
    <Trans i18nKey="c.l.sidebar.1100.skincarepro.title">Skincare Pro</Trans>
  ),
  path: '/',
};

export default [
  <SingleColumnLayout
    exact
    key="q"
    path="/skincare-pro/ui-configuration/overview"
    component={AsyncMenu}
    title={<Trans i18nKey="p.s.uiconfiguration.title">UI Configuration</Trans>}
    parents={[parent4]}
  />,
  <UiConfiguarationLayout
    exact
    key="n"
    path="/skincare-pro/ui-configuration/common-settings"
    component={AsyncCommonPage}
    title={
      <Trans i18nKey="p.s.uiconfiguration.tabs.common.settings">
        Common Settings
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="a"
    path="/skincare-pro/ui-configuration/name-preferences"
    component={AsyncAppSettings}
    title={<Trans i18nKey="p.s.app.settings.title">Name Preferences</Trans>}
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="a"
    path="/skincare-pro/ui-configuration/landing-page"
    component={AsyncLandingPage}
    title={
      <Trans i18nKey="p.s.uiconfiguration.landingpage.title">
        Landing Page
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="o"
    path="/skincare-pro/ui-configuration/landing"
    component={AsyncLandingPageV2}
    title={
      <Trans i18nKey="p.s.uiconfiguration.landingpage.title">
        Landing Page
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="o"
    path="/skincare-pro/ui-configuration/user-consent"
    component={AsyncUserConsent}
    title={
      <Trans i18nKey="p.s.c.customization.user.consent">User Consent</Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="e"
    path="/skincare-pro/ui-configuration/survey-form"
    component={AsyncSurveyFormConfig}
    title={
      <Trans i18nKey="c.l.sidebar.1150.skincarepro.title">Survey Form</Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="b"
    path="/skincare-pro/ui-configuration/skincare-detection"
    component={AsyncSkincareDetection}
    title={
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.title">
        Skincare Detection
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="c"
    path="/skincare-pro/ui-configuration/skin-result-page"
    component={AsyncSkinResultPage}
    parents={[parent1]}
    title={
      <Trans i18nKey="p.s.uiconfiguration.skinresultpage.title">
        Skin Result Page
      </Trans>
    }
  />,
  <UiConfiguarationLayout
    exact
    key="p"
    path="/skincare-pro/ui-configuration/skin-result"
    component={AsyncSkinResultPageV2}
    parents={[parent1]}
    title={
      <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skingetresult.title">
        Skin Result Page & Get Skin Result Page
      </Trans>
    }
  />,
  <UiConfiguarationLayout
    exact
    key="d"
    path="/skincare-pro/ui-configuration/get-skin-result"
    component={AsyncGetSkinResult}
    title={
      <Trans i18nKey="p.s.uiconfiguration.getskinresult.title">
        Get Skin Result
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="d"
    path="/skincare-pro/ui-configuration/shared-skin-result-page" //above v2
    component={AsyncSharedSkinResultPage}
    title={
      <Trans i18nKey="p.s.uiconfiguration.sharedskinresultpage.title">
        Shared Skin Result Page
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="r"
    path="/skincare-pro/ui-configuration/simulation-page"
    component={AsyncSimulationPage}
    title={
      <Trans i18nKey="p.s.uiconfiguration.simulation.page">
        Simulation Page
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="s"
    path="/skincare-pro/ui-configuration/simulation-report"
    component={AsyncSimulationReport}
    title={
      <Trans i18nKey="p.s.uiconfiguration.simulationresultpage.getsimulationresult.title">
        Simulation Report Page & Get Simulation Report Page
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="t"
    path="/skincare-pro/ui-configuration/shared-simulation-report-page" //above v2
    component={AsyncSharedSimulationReportPage}
    title={
      <Trans i18nKey="p.s.uiconfiguration.sharedsimulationreportpage.title">
        Shared Simulation Report Page
      </Trans>
    }
    parents={[parent1]}
  />,
  <UiConfiguarationLayout
    exact
    key="u"
    path="/skincare-pro/ui-configuration/face-assessment"
    component={AsyncFaceAssessment}
    title={
      <Trans i18nKey="p.s.uiconfiguration.face.assessment.page">
        Face Assessment Page
      </Trans>
    }
    parents={[parent1]}
  />,
  <SingleColumnLayout
    exact
    key="h"
    path="/skincare-pro/add-skincare/skincare-product"
    component={AsyncSkincareProduct}
    parents={[parent2]}
    className="skincare-product"
    title={
      <Trans i18nKey="p.s.addskincare.skincareproduct">Skincare Product</Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="i"
    path="/skincare-pro/add-skincare/skincare-routine"
    component={AsyncSkincareRoutine}
    parents={[parent2]}
    className="skincare-routine"
    title={
      <Trans i18nKey="p.s.addskincare.skincareroutine">Skincare Routine</Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="j"
    path="/skincare-pro/add-skincare/skincare-treatment"
    component={AsyncSkincareTreatment}
    parents={[parent2]}
    className="skincare-treatment"
    title={
      <Trans i18nKey="p.s.addskincare.skincaretreatment">
        Skincare Treatment
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="k"
    path="/skincare-pro/add-skincare/add-skincare-product"
    component={AsyncAddOrEditSkincareProduct}
    parents={[parent2]}
    className="add-skincare-product"
    title={
      <Trans i18nKey="p.s.addskincare.add.skincare.product">
        Add Skincare Product
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="m"
    path="/skincare-pro/add-skincare/edit-skincare-product"
    component={AsyncAddOrEditSkincareProduct}
    parents={[parent2]}
    title={
      <Trans i18nKey="p.s.addskincare.edit.skincare.product">
        Edit Skincare Product
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="i"
    path="/skincare-pro/add-skincare/add-skincare-routine"
    component={AsyncAddOrEditSkincareRoutine}
    parents={[parent2]}
    className="skincare-routine"
    title={
      <Trans i18nKey="p.s.addskincare.skincareroutine">
        Add Skincare Routine
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="i"
    path="/skincare-pro/add-skincare/edit-skincare-routine"
    component={AsyncAddOrEditSkincareRoutine}
    parents={[parent2]}
    className="skincare-routine"
    title={
      <Trans i18nKey="p.s.addskincare.skincareroutine">
        Edit Skincare Routine
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="k"
    path="/skincare-pro/add-skincare/add-skincare-treatment"
    component={AsyncAddOrEditSkincareTreatment}
    parents={[parent2]}
    className="add-skincare-treatment"
    title={
      <Trans i18nKey="p.s.addskincare.add.skincare.treatment">
        Add Skincare Treatment
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="k"
    path="/skincare-pro/add-skincare/edit-skincare-treatment"
    component={AsyncAddOrEditSkincareTreatment}
    parents={[parent2]}
    className="edit-skincare-treatment"
    title={
      <Trans i18nKey="p.s.addskincare.edit.skincare.treatment">
        Edit Skincare Treatment
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="k"
    path="/skincare-pro/add-skincare/list-product-category"
    component={AsyncCategoryManagement}
    parents={[parent2]}
    className="list-product-category"
    title={
      <Trans i18nKey="p.s.addskincare.product.category.management">
        Product Category Management
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="k"
    path="/skincare-pro/add-skincare/list-treatment-category"
    component={AsyncCategoryManagement}
    parents={[parent2]}
    className="list-treatment-category"
    title={
      <Trans i18nKey="p.s.addskincare.treatment.category.management">
        Treatment Category Management
      </Trans>
    }
  />,
  <SingleColumnLayout
    exact
    key="l"
    path="/skincare-pro/recommendation-rule/rule-based/edit/:settingId"
    component={AsyncRuleBasedRecommendation}
    parents={[parent3]}
    className="skincare-product"
    title={<Trans i18nKey="p.s.recommendation.rule">Recommendation Rule</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="l"
    path="/skincare-pro/recommendation-rule/rule-based/view/:settingId"
    component={AsyncRuleBasedRecommendation}
    parents={[parent3]}
    className="skincare-product"
    title={<Trans i18nKey="p.s.recommendation.rule">Recommendation Rule</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="t"
    path="/skincare-pro/recommendation-rule/ai-recommendation/:settingId"
    component={AsyncAiRecommendation}
    parents={[parent3]}
    className="skincare-product"
    title={<Trans i18nKey="p.s.recommendation.rule">Recommendation Rule</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="t"
    path="/skincare-pro/recommendation-rule/ai-recommendation/view/:settingId"
    component={AsyncAiRecommendation}
    parents={[parent3]}
    className="skincare-product"
    title={<Trans i18nKey="p.s.recommendation.rule">Recommendation Rule</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="t"
    path="/skincare-pro/recommendation-rule/customized/edit/:settingId"
    component={AsyncCustomizedRecommendation}
    parents={[parent3]}
    className="skincare-product"
    title={<Trans i18nKey="p.s.recommendation.rule">Recommendation Rule</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="t"
    path="/skincare-pro/recommendation-rule/customized/view/:settingId"
    component={AsyncCustomizedRecommendation}
    parents={[parent3]}
    className="skincare-product"
    title={<Trans i18nKey="p.s.recommendation.rule">Recommendation Rule</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="l"
    path="/skincare-pro/recommendation-rule"
    component={AsyncRecommendationList}
    parents={[parent3]}
    className="skincare-product"
    title={<Trans i18nKey="p.s.recommendation.rule">Recommendation Rule</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="m"
    path="/skincare-pro/email-customization"
    component={AsyncEmailCustomization}
    parents={[parent5]}
    className="skincare-email-customization"
    title={<Trans i18nKey="p.s.email.customization">Email Customization</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="n"
    path="/skincare-pro/survey-form"
    component={AsyncSurveyForm}
    parents={[parent5]}
    className="skincare-survey-form"
    title={<Trans i18nKey="p.s.survey.form.title">Survey Form</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="o"
    path="/skincare-pro/survey-form/add"
    component={AddOrEditOrViewSurveyForm}
    parents={[parent5]}
    className="skincare-survey-form"
    title={<Trans i18nKey="p.s.survey.form.title">Survey Form</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="o"
    path="/skincare-pro/survey-form/view/:id"
    component={AddOrEditOrViewSurveyForm}
    parents={[parent5]}
    className="skincare-survey-form"
    title={<Trans i18nKey="p.s.survey.form.title">Survey Form</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="o"
    path="/skincare-pro/survey-form/edit/:id"
    component={AddOrEditOrViewSurveyForm}
    parents={[parent5]}
    className="skincare-survey-form"
    title={<Trans i18nKey="p.s.survey.form.title">Survey Form</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="o"
    path="/skincare-pro/survey-form/translate/:id"
    component={EditTranslateSurveyForm}
    parents={[parent5]}
    className="skincare-survey-form"
    title={<Trans i18nKey="p.s.survey.form.title">Survey Form</Trans>}
  />,
  <Redirect key="e" exact from="/skincare-pro" to="/" />,
  <Redirect
    key="f"
    exact
    from="/skincare-pro/ui-configuration"
    to="/skincare-pro/ui-configuration/landing-page"
  />,
  <Redirect
    key="g"
    exact
    from="/skincare-pro/add-skincare"
    to="/skincare-pro/add-skincare/skincare-product"
  />,
];
